import * as React from 'react';
import classnames from 'classnames';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { Context } from '@grandvisionhq/carts-v2';
import { ProductBlock } from '@grandvisionhq/lib-visuals';
import { pushAddFromMiniCartEvent } from '../../../../../DataLayer/data-layer.js';
import { useProductLink } from '../../../../../utils/use-product-link.js';
import { pushProductImpressions, pushProductClick } from '../../../utils/data-layer.js';
import { getZeroDiscount } from '../../../utils/get-zero-discount.js';
import { getProductRecommendationAction } from '../../../utils/mappers.js';
import { ProductBlockAction } from './components/ProductBlockAction/ProductBlockAction.js';

const ProductRecommendationBlock = ({ className , recommendation , position , showAsCard , tabIndex ,  })=>{
    var ref, ref1, ref2, ref3;
    const link = useProductLink(recommendation.slug, recommendation.sku, recommendation.productType);
    const { wasSeen , ref: ref4  } = useWasSeenByUser();
    React.useEffect(()=>{
        if (wasSeen) {
            pushProductImpressions(recommendation, position);
        }
    }, [
        position,
        recommendation,
        wasSeen
    ]);
    const handleClick = ()=>{
        pushProductClick(recommendation, position);
    };
    const { cart  } = Context.useCart();
    const handleAddProduct = ()=>{
        pushAddFromMiniCartEvent(recommendation.sku, recommendation.name, recommendation.brand, recommendation.productType, recommendation.price.value.centAmount, recommendation.price.discounted ? recommendation.price.discounted.value.centAmount : recommendation.price.value.centAmount, cart === null || cart === void 0 ? void 0 : cart.id);
    };
    const frontImage = (ref = recommendation.images) === null || ref === void 0 ? void 0 : ref[0];
    const angleImage = (ref1 = recommendation.images) === null || ref1 === void 0 ? void 0 : ref1[1];
    const tag = getZeroDiscount(recommendation) || ((ref2 = recommendation.tags) === null || ref2 === void 0 ? void 0 : ref2[0]);
    const heading = recommendation.brand;
    const caption = recommendation.name || recommendation.brandModel || '';
    var _action;
    const action = getProductRecommendationAction((_action = recommendation.action) !== null && _action !== void 0 ? _action : undefined);
    return /*#__PURE__*/ React.createElement(ProductBlock.Outer, {
        className: classnames(className, 'product-recommendation-block', {
            'product-recommendation-block--card': showAsCard
        }),
        ref: ref4
    }, /*#__PURE__*/ React.createElement(ProductBlock.Inner, null, /*#__PURE__*/ React.createElement(ProductBlock.Header, null, /*#__PURE__*/ React.createElement(ProductBlock.Header.Left, {
        tag: tag
    })), /*#__PURE__*/ React.createElement(ProductBlock.Details, {
        href: link,
        onClick: handleClick,
        tabIndex: tabIndex
    }, /*#__PURE__*/ React.createElement(ProductBlock.Details.Heading, null, heading), /*#__PURE__*/ React.createElement(ProductBlock.Details.Caption, null, caption)), /*#__PURE__*/ React.createElement(ProductBlock.Images, {
        href: link,
        onClick: handleClick,
        frontUrl: (frontImage === null || frontImage === void 0 ? void 0 : frontImage.url) || '',
        frontAlt: (frontImage === null || frontImage === void 0 ? void 0 : frontImage.label) || undefined,
        angleUrl: angleImage === null || angleImage === void 0 ? void 0 : angleImage.url
    }), /*#__PURE__*/ React.createElement(ProductBlock.Pricing, {
        originalPrice: recommendation.price.value.centAmount,
        discountedPrice: (ref3 = recommendation.price.discounted) === null || ref3 === void 0 ? void 0 : ref3.value.centAmount,
        discountLabel: recommendation.promotionLabel || '',
        currency: recommendation.price.value.currencyCode,
        isCentAmount: true
    }), action && /*#__PURE__*/ React.createElement(ProductBlock.Footer, null, /*#__PURE__*/ React.createElement(ProductBlockAction, {
        activeSku: recommendation.sku,
        productType: recommendation.productType,
        action: action,
        onAddProduct: handleAddProduct,
        tabIndex: tabIndex
    }))));
};

export { ProductRecommendationBlock };
//# sourceMappingURL=ProductRecommendationBlock.js.map
